import React from 'react';
import { Box } from '@mui/material';
import RateList from '../../components/Reports/RateList';

const RateListPage: React.FC = () => {
  return (
    <Box>
      <RateList type="RATE_LIST" />
    </Box>
  );
};

export default RateListPage;